// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageDeleted-modulecard__rpxFg ChatroomMessageBody-modulechatroomMessageBody__jbhQC";
var _2 = "ChatroomMessageDeleted-modulecardOwn___Eu8F ChatroomMessageBody-modulechatroomMessageBodyOwn__B1Hfa";
var _3 = "ChatroomMessageDeleted-modulechatroomMessageDeleted__hKRTe ChatroomMessage-modulechatroomMessage__uZUyV";
var _4 = "ChatroomMessageDeleted-modulechatroomMessageDeletedOwn__0UNoa ChatroomMessage-modulechatroomMessageOwn__Jma_d";
var _5 = "ChatroomMessageDeleted-modulecolumn__ugtzw ChatroomMessage-modulecolumn__eOvb9";
export { _1 as "card", _2 as "cardOwn", _3 as "chatroomMessageDeleted", _4 as "chatroomMessageDeletedOwn", _5 as "column" }
